import React, { useRef } from "react";
import TheGreatSage from "../mantra/TheGreatSage";
import AshramaFaculty from "../mantra/AshramaFaculty";
import AshramaBenefits from "../mantra/AshramaBenefits";
import FinestKnowledge from "../mantra/FinestKnowledge";
import ContactUs from "../common/ContactUs";
import SahajYogaCard from "../common/SahajYogaCard";
import TheSupreme from "../homepage/TheSupreme";
import DivineCharacteristics from "../homepage/DivineCharacteristics";
import HeaderOnly from "../common/HeaderOnly";
import Footer from "../common/Footer";
import Hero from "../mantra/Hero";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";

const Mantra = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      const section = document.getElementById(location.hash.substr(1));
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth",
        });
      }
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  const myRef = useRef(null);
  const scrollToRef = () => {
    if (myRef.current) {
      myRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      {/* <Hero /> */}
      <HeaderOnly />
      <TheSupreme />
      <TheGreatSage />
      <DivineCharacteristics />

      <AshramaBenefits />

      <ContactUs ContactUsREf={myRef}/>
      <SahajYogaCard click={scrollToRef} />
      <Footer />
    </>
  );
};

export default Mantra;
